'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.omit = exports.ls = exports.isInWechat = exports.isEmptyObject = undefined;
exports.isInIOS = isInIOS;
exports.filterEqual = filterEqual;

var _local_storage = require('./local_storage');

var localStorage = _interopRequireWildcard(_local_storage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var isEmptyObject = exports.isEmptyObject = function isEmptyObject(o) {
    return Object.keys(o).length === 0 && o.constructor === Object;
};

var isInWechat = exports.isInWechat = function isInWechat() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigator.userAgent.toLowerCase();

    var reg = /MicroMessenger/i;
    return reg.test(ua);
};

function isInIOS() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigator.userAgent.toLowerCase();

    var reg = /iPad|iPhone|iPod/i;
    return reg.test(ua) && !window.MSStream;
}

function filterEqual(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
}

var ls = exports.ls = localStorage;

var omit = exports.omit = function omit(obj, keys) {
    var a = JSON.parse(JSON.stringify(obj));
    keys.forEach(function (key) {
        return delete a[key];
    });
    return a;
};


//////////////////
// WEBPACK FOOTER
// ./src/js/utils/index.js
// module id = 865
// module chunks = 0